import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import LabeledTextArea from "../../components/LabeledTextArea";
import { Spinner } from "../../components/Spinner";
import { plausible } from "../../utils/plausible";
import { generateUUID } from "../../utils/uuid";
import {
  getSelectedTeamId,
  selectProduct,
} from "../navigation/navigationSlice";
import {
  initialProductMutation,
  ProductDetails,
  ProductMutation,
  useCreateProductMutation,
} from "./productApiSlice";

const ProductMutationPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [productMutation, setProductRequest] = useState(initialProductMutation);

  const [createProduct, { isLoading }] = useCreateProductMutation();

  const selectedTeamId = useSelector(getSelectedTeamId);

  const handleChange = (key: keyof ProductMutation) => (value: string) => {
    setProductRequest((prevProductMutation) => ({
      ...prevProductMutation,
      [key]: value,
    }));
  };

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const id = generateUUID();
    plausible("ProductCreated", { productId: id });
    createProduct({ ...productMutation, id: id, teamId: selectedTeamId })
      .unwrap()
      .then((product: ProductDetails) => dispatch(selectProduct(product.id)))
      .then(() => navigate("/dashboard"));
  };

  return (
    <div>
      <h1 className="text-4xl font-bold tracking-tight">Product</h1>
      <div className="py-2">
        <form onSubmit={handleSubmit} className="space-y-4">
          <LabeledTextArea
            key="name"
            id="name"
            name="name"
            value={productMutation.name}
            onChange={handleChange("name")}
            label="Name"
          />

          <div className="flex items-center space-x-2">
            <button
              type="submit"
              className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-orange-600 hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500 disabled:opacity-75"
              disabled={isLoading || productMutation.name.length < 3}
            >
              Save
            </button>
            <div>{isLoading && <Spinner />}</div>
          </div>
        </form>
      </div>
    </div>
  );
};
export default ProductMutationPage;
